export const GET_ACADEMIES = "GET_ACADEMIES";
export const GET_ACADEMY_BY_ID = "GET_ACADEMY_BY_ID";
export const UPDATE_ACADEMY = "UPDATE_ACADEMY";
export const DELETE_ACADEMY = "DELETE_ACADEMY";
export const CREATE_ACADEMY = "CREATE_ACADEMY";
export const GET_ACADEMY_PROGRAMS = "GET_ACADEMY_PROGRAMS";
export const GET_ACADEMIES_LIGHT = "GET_ACADEMIES_LIGHT";
export const ACADEMY_SEARCH = "ACADEMY_SEARCH";
